import * as React from "react"
import { useTranslation } from "react-i18next"
import styled from "styled-components"
import { HorizontalSpacer } from "../../atoms/spacers"
import H3 from "../../atoms/typography/H3"
import H4 from "../../atoms/typography/H4"
import PrimaryButton from "../../atoms/buttons/PrimaryButton"
import Body from "../../atoms/typography/Body"
import { theme } from "../../theme"

interface Props {
  onClose: () => void
  onClickDelete: () => void
  memberName: string
  userHasBeenRemoved?: boolean
}

const ContentContainer = styled.div`
  padding: ${(props) => `${props.theme.spacings.large} ${props.theme.spacings.larger}`};
`

const ActionButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

const RemoveMemberFromOrgOrGroupModalContent: React.FunctionComponent<Props> = ({
  onClose,
  onClickDelete,
  memberName,
  userHasBeenRemoved,
}) => {
  const { t } = useTranslation()

  return (
    <ContentContainer>
      <H4 textAlign="center">Are you sure you want to remove {memberName}?</H4>
      <HorizontalSpacer spacing={2} />
      <H3 textAlign="center"></H3>
      <HorizontalSpacer spacing={3} />
      <ActionButtonContainer>
        <PrimaryButton title="Remove member" onClick={onClickDelete} destructive />
        <PrimaryButton title={t("common.cancel")} onClick={onClose} />
      </ActionButtonContainer>
      {userHasBeenRemoved && <Body color={theme.colors.greenDark}>User has been deleted</Body>}
    </ContentContainer>
  )
}

export default RemoveMemberFromOrgOrGroupModalContent
